import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_ContentForm = _resolveComponent("ContentForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.edit'),
      title: _ctx.$t('page.edit_content')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.content_categories'),
          to: "/contents"
        }, null, 8 /* PROPS */, ["page"]),
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.contents'),
          to: `/content-category/${_ctx.category_id}`
        }, null, 8 /* PROPS */, ["page", "to"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page", "title"]),
    _createVNode(_component_ContentForm)
  ], 64 /* STABLE_FRAGMENT */))
}